<script setup lang="ts">
import { Trophy, ShieldCheck, Activity, Users } from 'lucide-vue-next';
</script>

<template>
  <div class="min-h-screen bg-slate-950 flex flex-col justify-center py-12 sm:px-6 lg:px-8 relative overflow-hidden">
    <!-- Decorative background glow -->
    <div class="absolute -top-40 -left-40 w-96 h-96 bg-sky-500/10 rounded-full blur-3xl pointer-events-none" />
    <div class="absolute -bottom-40 -right-40 w-96 h-96 bg-indigo-500/10 rounded-full blur-3xl pointer-events-none" />

    <div class="sm:mx-auto sm:w-full sm:max-w-md text-center z-10">
      <div class="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-gradient-to-tr from-sky-500 to-indigo-600 text-white shadow-xl shadow-sky-500/20 mb-4">
        <Trophy class="w-7 h-7" />
      </div>
      <h1 class="text-2xl font-extrabold tracking-tight text-slate-100">
        Next Base Team Cloud
      </h1>
      <p class="mt-1 text-xs text-slate-400 font-medium">
        Multi-Tenant Baseball Operations & Roster Hub
      </p>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-lg z-10 px-4">
      <div class="bg-slate-900 border border-slate-800 py-8 px-6 sm:px-10 rounded-3xl shadow-2xl">
        <router-view />
      </div>
    </div>
  </div>
</template>